<template>
  <div class="chart-inner" ref="multiProgress" />
</template>

<script>
/* eslint-disable */
import * as d3 from "d3";
import d3Tip from "d3-tip";

export default {
  props: {
    progress: [String, Number, Array],
    previous: [String, Number],
    refraction: [Object],
    previousRefraction: [Object],
    colorOverride: [String],
    percentColorOverride: [String],
    mob: [Boolean]
  },

  watch: {
    refraction(newVal) {
      this.$refs.multiProgress.innerHTML = "";
      this.draw();
    },
    previousRefraction(newVal) {
      this.$refs.multiProgress.innerHTML = "";
      this.draw();
    }
  },

  mounted() {
    this.draw();
  },

  methods: {
    draw() {
      const tau = 2 * Math.PI;
      const element = this.$el;
      const width = 550;
      const height = 400;
      const radius = width / 2;
      const viewBox = `0 0 ${width} ${height}`;
      const fontSize = width / 4.2;
      const { percentageValue, sumValue, donutData } = this.refraction;
      // const { previousPercentageValue } = this.previousRefraction;

      const svg = d3
        .select(element)
        .append("svg")
        .attr("viewBox", viewBox);

      const tip = d3Tip()
        .attr("class", "tooltip-multi")
        .direction(function(d) {
          if (d.data.name === "yes") return "n";
          if (d.data.name === "no") return "w";
          if (d.data.name === "not_sure") return "e";
          return "n";
        })
        .html(function(d) {
          return `<div class="label">${d.data.name.replace(
            /_/g,
            " "
          )}: ${d.value}</span></span>`;
        });

      const g = svg
        .append("g")
        .attr("transform", `translate(${width / 2}, ${height / 2})`);

      g.call(tip);

      const arcFunction = d3
        .arc()
        .innerRadius(radius - (this.mob ? 85 : 91))
        .outerRadius(radius - 110); //99);

      const pie = d3
        .pie()
        .startAngle(0)
        .endAngle(2 * Math.PI)
        .padAngle(0.03)
        .sort(null)
        .value(d => d.value);

      if (donutData) {
        const dData = donutData.filter(function(item) {
          return item.name != "not_sure";
        });
        const g3 = svg
          .selectAll(".path")
          .data(pie(donutData))
          .enter()
          .append("g")
          .attr("transform", `translate(${width / 2}, ${height / 2})`)
          .on("mouseover", tip.show)
          .on("mouseout", tip.hide)
          .attr("class", "path");

        g3.append("path")
          .attr("fill", (d, i) => pickColor(d, this))
          // .attr("d", arcFunction)
          .transition()
          .delay(function(d, i) {
            return i * 1050;
          })
          .duration(1500)

          .attrTween("d", arcTween(tau))
          .style("cursor", "pointer");
      }

      const text = g
        .append("text")
        .text(this.progress === "N/A" ? "N/A" : "0")
        .attr("class", "percentage-text")
        .attr("text-anchor", "middle")
        .style("font-size", fontSize + "px")
        .style("font-weight", "normal")
        .attr("dy", (height / 10) + 5);

      if (this.progress !== "N/A") {
        if (this.percentColorOverride) {
          g.append("text")
            .text("%")
            .attr("fill", this.percentColorOverride)
            .style("font-size", fontSize / 3 + "px")
            .style("font-weight", "bold")
            .attr("x", 70);
        } else {
          g.append("text")
            .text("%")
            .attr("class", "percentage-text")
            .style("font-size", fontSize / 3 + "px")
            .style("font-weight", "bold")
            .attr("x", 70);
        }
      }

      const format = d3.format(",d");

      if (this.progress !== "N/A") {
        const tweenElement = this.$refs.multiProgress;
        const numberAnimate = d3
          .select(tweenElement)
          .transition()
          .duration(2500)
          .on("start", function repeat() {
            d3.active(this)
              .tween("text", function() {
                const i = d3.interpolateNumber(
                  text.text().replace(/,/g, ""),
                  percentageValue
                );
                return function(t) {
                  text.text(format(i(t)));
                };
              })
              .transition()
              .delay(1500)
              .on("start", repeat);
          });
      }
      var nodeWidth = d => d.getBBox().width;

      const legend = svg
        .append("g")
        .attr("class", "legend")
        .attr("transform", "translate(0,0)");

      const lg = legend
        .selectAll("g")
        .data(donutData)
        .enter()
        .append("g")
        .attr("transform", (d, i) => `translate(${i * 100},${height + 15})`);

      lg.append("rect")
        .style("fill", d => pickColor(d, this))
        .attr("x", 0)
        .attr("y", 0)
        .attr("width", 10)
        .attr("height", 10);

      lg.append("text")
        .style("font-size", "14px")
        .style("font-weight", "100")
        .style("opacity", "0.7")
        .attr("x", 17.5)
        .attr("y", 10)
        .text(d => {
          return capitalize(d.name.replace("_", " ")) + ` (${d.value})`;
        });

      let offset = 0;
      lg.attr("transform", function(d, i) {
        let x = offset;
        offset += nodeWidth(this) + 10;
        return `translate(${x},${height + 10})`;
      });

      legend.attr("transform", function() {
        return `translate(${(width - nodeWidth(this)) / 2},${5})`;
      });

      // if (
      //   donutData &&
      //   (this.previous === "under_10_answers" ||
      //     (this.refraction.percentageValue &&
      //       this.previousRefraction.percentageValue))
      // ) {
      //   let dataset = [
      //     // {x: 1, y: Math.floor(Math.random() * 100)},
      //     { x: 1, y: this.previousRefraction.percentageValue },
      //     { x: 2, y: this.refraction.percentageValue }
      //   ];

      //   if (this.previous === "under_10_answers") {
      //     dataset = [
      //       { x: 1, y: 80 },
      //       { x: 2, y: 100 }
      //     ];
      //     if (this.isDysphotopsia) {
      //       dataset = [
      //         { x: 1, y: 20 },
      //         { x: 2, y: 10 }
      //       ];
      //     }
      //   }

      //   const options = {
      //     margin: { top: 0, right: 0, bottom: 0, left: 0 },
      //     height: 0,
      //     width: 300
      //   };
      //   const margin = {
      //     top: options.margin.top || 0,
      //     right: options.margin.right || 0,
      //     bottom: options.margin.bottom || 0,
      //     left: options.margin.left || 0
      //   };
      //   const width2 = options.width - margin.left - margin.right;
      //   const height2 = options.height - margin.top - margin.bottom;

      //   const randomNumber = Math.floor(Math.random() * 10000000);

      //   const xScale = d3
      //     .scaleLinear()
      //     .domain([0, getMaxValue(dataset, "x")])
      //     .range([0, 60]);

      //   const yScale = d3
      //     .scaleLinear()
      //     .domain([0, getMaxValue(dataset, "y")])
      //     .range([25, 0]);

      //   const g2 = svg.append("g").attr("transform", "translate(260,299)");

      //   const line = d3
      //     .line()
      //     .x((d, i) => xScale(i))
      //     .y((d, i) => yScale(d.y));

      //   const linearGradient = g2
      //     .append("defs")
      //     .append("linearGradient")
      //     .attr("id", `linear-gradient${randomNumber}`);

      //   linearGradient
      //     .append("stop")
      //     .attr("offset", "30%")
      //     .attr("stop-color", pickCircleColor(dataset[0].y));

      //   linearGradient
      //     .append("stop")
      //     .attr("offset", "70%")
      //     .attr("stop-color", pickCircleColor(dataset[1].y));

      //   g2.append("path")
      //     .datum(dataset)
      //     .attr("class", "line")
      //     .attr("d", line)
      //     .attr("stroke", `url(#linear-gradient${randomNumber})`)
      //     .attr("fill", "none");

      //   g2.selectAll(".dot")
      //     .data(dataset)
      //     .enter()
      //     .append("circle")
      //     .attr("class", "dot")
      //     .attr("cx", (d, i) => xScale(i))
      //     .attr("cy", (d, i) => yScale(d.y))
      //     .attr("r", 6)
      //     .attr("stroke", (d, i) => pickCircleColor(d.y))
      //     .attr("fill", "#fff");
      // }

      function getMaxValue(dataset, key) {
        const max = dataset.reduce((a, b) => (a[key] > b[key] ? a : b));
        return max[key];
      }

      function arcTween(newAngle) {
        return function(d) {
          const interpolate = d3.interpolate(d.startAngle + 0.1, d.endAngle);
          return function(t) {
            d.endAngle = interpolate(t);
            return arcFunction(d);
          };
        };
      }

      function capitalize(word) {
        return word
          .split(" ")
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      }

      function pickColor(obj, self) {
        const positives = [
          'yes', 'yes_definitely', 'yes_to_some_extent',
          'very_good', 'good', 'extremely_likely', 'likely'
        ]
        if (obj && obj.data) {
          const pathName = obj.data.name;

          if (self.colorOverride) {
            if (positives.includes(pathName)) {
              return self.colorOverride;
            } else if (pathName === "not_sure") {
              return self.colorOverride;
            } else {
              return "#DDDDDD";
            }
          } else {
            if (positives.includes(pathName)) {
              return "#21931B";
            } else if (pathName === "not_sure") {
              return "#FFD167";
            } else {
              return "#C60E2B";
            }
          }
        }

        if (obj && obj.value) {
          if (self.colorOverride) {
            return self.colorOverride;
          }

          const percentage = parseInt((obj.value / sumValue) * 100);

          if (percentage <= 25) {
            return "#C60E2B";
          } else if (percentage <= 40) {
            return "#F27830";
          } else if (percentage <= 55) {
            return "#FFD167";
          } else if (percentage <= 80) {
            return "#8BC34A";
          } else {
            return "#21931B";
          }
        }
      }
    }
  }
};
/* eslint-enable */
</script>

<style lang="sass">
@import "../../../styles/helpers/_mixins.sass"
@import "../../../styles/base/variables"

.chart-inner
  cursor: pointer
  font-weight: light

.percentage-text
  fill: $color-side-nav

.color-default
  fill: $color-body-bg

.color-very-diss
  fill: $color-very-diss

.color-diss
  fill: $color-diss

.color-neutral
  fill: $color-neutral

.color-satisfied
  fill: $color-satisfied

.color-very-satisfied
  fill: $color-very-satisfied

.line
  stroke-width: 6

.dot
  transition: all .05s ease-in-out
  stroke-width: 6

.tooltip-multi
  background: #fff
  border-radius: 6px
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2)
  color: #333
  font-size: 12px
  padding: 10px
  position: absolute
  text-align: center
  max-width: 120px
  min-width: 40px
  z-index: 1050
  display: block

  ::first-letter
    text-transform: uppercase
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/charts/MultipleAnswers.vue